module.exports = __webpack_public_path__ + "static/media/bluSerwer-logo-white.835ebf51.png";